import './App.css';
import Introduction from './stages/Introduction';
import Core from './stages/Core';
import Footer from './stages/Footer';

function App() {

  return (
    <div className="App">
      <Introduction></Introduction>
      <Core></Core>
      <Footer></Footer>
    </div>
  );
}

export default App;
